import React, { Fragment, useState, useEffect } from "react";
import { Menu, Transition } from "@headlessui/react";
// import { ChevronDownIcon } from "@heroicons/react/solid";
// import styled from 'styled-components'
import { ChevronDown } from "@styled-icons/bootstrap";
import ToggleButton from "../ToggleButton";
import {
  BlockchainName,
  DepositMethod,
  DepositMethods,
  DevType,
  UserBalance,
  UserBalances,
} from "../../typings";
import { capitalizeFirstLetter, formatCryptoDecimals } from "../../utils/misc";

// adding ./eth.png will make it look for the image from public folder, when we actually want to look for it from the dist

// const BtcIcon = styled(Btc)`
//   color: orange;
// `

// const LtcIcon = styled(Ltc)`
//   color: gray;
// `
// const DogeIcon = styled(Doge)`
//   color: gold;
// `
// const XrpIcon = styled(Xrp)`
//   color: black;
// `
// const BnbIcon = styled(Bnb)`
//   color: gold;
// `

type Args = {
  depositMethods: DepositMethods;
  type: DevType;
  userBalances: UserBalances;
  displayInFiat: boolean;
  setDisplayInFiat: (arg: boolean) => void;
};

function DropdownMenu({
  depositMethods,
  type,
  userBalances,
  displayInFiat,
  setDisplayInFiat,
}: Args) {
  // console.log("DropdownMenu depositMethods", depositMethods);
  const [selectedBlockchainName, setSelectedBlockchainName] = useState<
    BlockchainName | ""
  >("");
  const [userBalance, setUserBalance] = useState<UserBalance>();
  const [selectedDepositMethod, setSelectedDepositMethod] =
    useState<DepositMethod | null>(null);

  useEffect(() => {
    for (const depositMethod of depositMethods) {
      if (depositMethod.blockchain.name === selectedBlockchainName) {
        setSelectedDepositMethod(depositMethod);
      }
    }
  }, [selectedBlockchainName]);
  useEffect(() => {
    for (const userBalance of userBalances) {
      if (userBalance.blockchainName === selectedBlockchainName) {
        setUserBalance(userBalance);
        break;
      }
    }
  }, [selectedBlockchainName, userBalances]);

  useEffect(() => {
    if (selectedBlockchainName || depositMethods.length === 0) return;
    setSelectedBlockchainName(depositMethods[0].blockchain.name);
    setSelectedDepositMethod(depositMethods[0]);
  }, [depositMethods]);

  function DisplayBalance() {
    if (!userBalance) return <span>0</span>;
    if (displayInFiat) {
      return <span className="text-sm font-medium text-white">${userBalance.fiat.usd}</span>;
    }

    return <span>{formatCryptoDecimals(userBalance.value)}</span>;
  }

  function BalanceInButton() {
    if (selectedDepositMethod === null) {
      return (
        <span className="inline-flex justify-center items-center">
          <DisplayBalance /> <ChevronDown className="ml-5" size={"16"} />
        </span>
      );
    }

    return (
      <span className="inline-flex justify-center items-center">
        <DisplayBalance />
        <img
          className="w-4 h-4 ml-5"
          src={selectedDepositMethod.symbolIcon}
          alt={selectedDepositMethod.blockchain.symbol}
        />
        <ChevronDown className="ml-1" size={"16"} />
      </span>
    );
  }

  return (
    <Fragment>
      <div className="">
        <Menu as="div" className="relative inline-block text-left">
          <div>
            <Menu.Button className=" items-center rounded-l-md hover:bg-gray-900 w-full bg-gray-700 px-4 py-2 text-sm font-medium text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75">
              <BalanceInButton />
            </Menu.Button>
          </div>
          <Transition
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Menu.Items className="absolute mt-2 w-56 origin-top-right divide-gray-100 bg-white rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
              <div className="px-1 py-1 w-full text-center text-sm text-black">
                Crypto ({capitalizeFirstLetter(type)} Mode)
              </div>

              {depositMethods.map((depositMethod) => {
                return (
                  <Menu.Item key={depositMethod.blockchain.name}>
                    <div
                      className="flex justify-between items-center p-3"
                      onClick={() =>
                        setSelectedBlockchainName(depositMethod.blockchain.name)
                      }
                    >
                      <p className="text-sm font-medium">
                        <DisplayBalance />
                      </p>
                      <div className="flex items-center">
                        <img
                          src={depositMethod.symbolIcon}
                          alt={depositMethod.blockchain.symbol}
                          className="w-4 h-4"
                        />

                        <p className="text-sm font-medium ml-1 text-black">
                          {depositMethod.symbol} (
                          {depositMethod.blockchain.name.toUpperCase()})
                        </p>
                      </div>
                    </div>
                  </Menu.Item>
                );
              })}

              <div className="px-1 py-1 border-t-2 border-gray-500">
                <Menu.Item>
                  <ToggleButton
                    onChange={(enabled: boolean) => setDisplayInFiat(enabled)}
                    initialValue={displayInFiat}
                  />
                </Menu.Item>
              </div>
            </Menu.Items>
          </Transition>
        </Menu>
      </div>
    </Fragment>
  );
}

export default DropdownMenu;
